import { axiosInstance } from './interceptor';

export class FileApi{

    // 图片上传
    static imageUpload = axiosInstance.defaults.baseURL + '/api/GenericUploadController/upload';
    
    // 
    static orderExport = axiosInstance.defaults.baseURL + '/api/orderClassController/export';
}
    
    
